__turbopack_context__.v({
  "root": "Carousal-module__b-px3q__root",
  "u-shimmer": "Carousal-module__b-px3q__u-shimmer",
});
